module.exports = __webpack_public_path__ + "static/media/Bathtub.be61fc3a.jpg";